import { track } from 'utils/tracking';
import { ITrackingProductPageBaseParameters } from '../shared/baseParameters';
import { fillItems, ITrackingFillItemsParameters } from '../shared/fillItems';
import {
  fillMarketingConsent,
  ITrackingFillMarketingConsentParameters,
} from '../shared/fillMarketingConsent';
import {
  fillRewardCampaign,
  ITrackingFillRewardCampaignParameters,
} from '../shared/fillRewardCampaign';

export const trackApplyNow = (
  parameters: Pick<ITrackingProductPageBaseParameters, 'leadId'> &
    ITrackingFillMarketingConsentParameters &
    ITrackingFillItemsParameters &
    ITrackingFillRewardCampaignParameters,
): void => {
  const { leadId } = parameters;

  return track({
    event: 'reward_gateway',
    step_number: '1',
    step_name: 'lead-submission',
    intent: 'Continue to Lead Details',
    login_method: '',
    search_result_parameter: '',
    ...fillMarketingConsent(parameters),
    lead_id: leadId,
    ...fillRewardCampaign(parameters),
    ...fillItems(parameters),
    component_type: 'bottom-sticky',
    component_title: 'CTA_Apply Now',
  });
};
